<template>
	<div id="app" class="app font handleTransitions handleShadowsAndNoise">

		<div class="contentModule contentModule--introText font font--sizeBig">
			<p :style="getIntroTextStyles()">
				<strong>In Kombination</strong> ist eine Agentur für Gestaltung in Leipzig.
				Wir arbeiten vorrangig in den Bereichen Editorial Design,
				Buch&shy;gestaltung, Ausstellungs&shy;gestaltung, Webdesign und Corporate Design. <br />
				Besonderen Wert legen wir auf Zusammen&shy;arbeit auf Augen&shy;höhe,
				individuelle Konzepte, den Inhalten angemessene Lösungen
				und gute Typografie.<br />
			</p>
			<p class="spacerLine">
				<br />
			</p>
			<p :style="getIntroTextStyles()">
				Wir freuen uns über Anfragen und Post unter
				<a href="mailto:info@in-kombination.de">info@in-kombination.de</a>
			</p>
		</div>
		<div class="contentModule contentModule--introSlider">
			<MhAgile	:autoplay="true"
						:autoplaySpeed="5000"
						:infinite="false"
						:arrows="false"
						:pauseOnDotsHover="true"
						:speed="350"
						:style="getAgileStyles()"
						@afterChange="onAfterSlide"
				>
				<div	v-for="(slide) in slides"
						:key="slide.image"
						:class="getSlideClasses(slide)">
					<div	class="agile__slideContent"
							:style="getContentStyles(slide)">
					</div>
				</div>
			</MhAgile>
		</div>
		<div class="contentModule contentModule--footerText font font--sizeSmall">
			<p :style="getFooterTextStyles()">
				In Kombination – Büro für Gestaltung<br />
				Helbing & Weißgerber GbR<br />
			</p>
			<p class="spacerLine">
				<br />
			</p>
			<p :style="getFooterTextStyles()">
				Karl-Liebknecht-Straße 36<br />
				04107 Leipzig<br />
			</p>
		</div>

		<template v-if="getHostname() == 'localhost'">
			<DevInfos></DevInfos>
		</template>

	</div>
</template>

<script>
	// @ is an alias to /src
	import DevInfos from '@/components/DevInfos/DevInfos.vue'
	import MhAgile from '@/components/MhAgile/MhAgile.vue'

	export default {
		name: 'App',
		components: {
			DevInfos,
			MhAgile,
		},
		data() {
			return {
				slides : [
					{	image : 'DO-Poster.jpg', 		ratio : 'p', color: 'rgb(62,171,237)' },
					{	image : 'GVT-iPhone.png', 		ratio : 'p', color: 'rgb(248,147,137)' },
					//{	image : 'FischerArt-Cuben.jpg', ratio : 'l', color: 'rgb(62,169,130)' },
					{	image : 'KI-Musik-Cover.jpg', 	ratio : 'p', color: 'rgb(136,12,136)' },
					{	image : 'Feuer-Key-Visual.jpg', ratio : 's', color: 'rgb(234,108,85)' },
					{	image : 'FStop-Journal.png', 	ratio : 'l', color: 'rgb(120,120,120)' },
					//{	image : 'ubl-Buchrücken.jpg', 	 ratio : 'p', color: 'rgb(165,197,138)' },
					{	image : 'ALL-Galaxy.png', 		ratio : 'l', color: 'rgb(245,80,103)' },
				],
				currentSlide : 0,
			}
		},
		computed: {
			color(){
				return this.slides[this.currentSlide].color
			}
		},
		methods: {
			onAfterSlide( payload ){
				console.log('sdsd - ' + payload.currentSlide);

				this.currentSlide = payload.currentSlide
				this.setFavicon(payload.currentSlide+1)
			},
			getHostname(){
				return window.location.hostname
			},
			getIntroTextStyles(){
				return {
					color : this.color
				}
			},
			getFooterTextStyles(){
				return {
					color : this.color
				}
			},
			getSlideClasses( slide ) {
				const slideIndex = this.slides.indexOf(slide)
				const currentIndex = this.currentIndex
				let elmClasses = ['agile__slide--ratio-' + slide.ratio]

				if( slideIndex == currentIndex ) {
					elmClasses.push('agile__slide--isActive')
				}

				return elmClasses
			},
			getContentStyles( slide ){
				return {
					backgroundImage : 'url(/sliderImages/'+slide.image+')',
				}
			},
			getAgileStyles(){
				const color = this.slides[this.currentSlide].color

				return {
					backgroundColor : color
				}
			},
			setColor( color ){
				this.$data.color = color
				//this.$forceUpdate();
				//console.log( 'App ' + color )
			},
			setFavicon( basename ){
				const faviconElm = document.querySelector('link[rel="icon"]')
				const faviconHref = '/favicons/' + basename + '.png'

				console.log('')
				console.log('setFavicon()')
				console.log('	faviconElm  :', faviconElm)
				console.log('	faviconHref : ' + faviconHref)

				faviconElm.setAttribute('href', faviconHref)
			},
		},
	}
</script>

<style lang="less">
	@import "less/vars.less";
	@import "less/includes/normalize.include.less";
	@import "less/includes/grid.include.less";

	.font {
		font-family: 'Work Sans', sans-serif;
		font-size: 16px;
		line-height: 19px;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}
	.font--sizeSmall {
		line-height: 1.2em;
		font-weight: @footerText__fontWeight;
		font-size: 1.1vw;

		@media @mediaQuery__xl {
			font-size: 1.3rem;
		}
		@media @mediaQuery__md {
			font-size: 1rem;
		}
		@media @mediaQuery__sm {
			font-size: 0.85rem;
		}
	}
	.font--sizeBig {
		//font-size: 1.5rem;
		font-size: 2vw;
		line-height: 1.25em;
		font-weight: @introText__fontWeight;
		letter-spacing: -0.01em;

		@media @mediaQuery__xl {
			font-size: 2.1rem;
		}
		@media @mediaQuery__lg {
			font-size: 1.9vw;
		}
		@media @mediaQuery__sm {
			font-size: 1.2rem;
		}
	}

	.handleTransitions {
		.contentModule--introText,
		.contentModule--introSlider,
		.contentModule--footerText {
			& > * {
				transition: inherit
			}
		}
		.contentModule--introText,
		.contentModule--footerText {
			transition: color @transitionDuration ease @transitionDelay;
		}
		.contentModule--introSlider .agile {
			transition: all @transitionDuration ease @transitionDelay;
		}
	}
	.handleShadowsAndNoise {
		transform: translateZ(1px);

		// noise particle
		XXX.agile::before {
			position: absolute;
			top: 0; left: 0;
			right: 0; bottom: 0;
			content: "";
			background-size: @noise__size;
			background-image: url(/noisyImages/noise-15--transparent.png);
			mix-blend-mode: soft-light;
			opacity: @noise__opacity;
		}
		// inset shadow
		XXX.introSlider__sliderContainer::after {
			position: absolute;
			top: 0; left: 0;
			right: 0; bottom: 0;
			content: "";

			box-shadow: 0px 0px 1.5rem fade(black, 15) inset;
			border-top: 1px solid fade(black, 10);
			mix-blend-mode: multiply;
		}
		// image shadow
		XXX.content {
			filter: drop-shadow( 1px 3px 5px rgba(0,0,0,0.4) );
		}
	}

	.app {
		position: absolute;
		top: 0; left: 0; right: 0; bottom: 0;

		-webkit-overflow-scrolling: touch; // ansonsten ist das ux absolut steif. wieder was gelernt :)
		overflow: hidden;
		overflow-y: auto;
	}

	.contentModule--introText,
	.contentModule--introSlider,
	.contentModule--footerText {
		position: absolute;
		width: 50vw;
		padding: 2vw;
		min-height: 1rem;
	}
	.contentModule--introText {
		top: 0; left: 0;

		strong {
			font-weight: @brand__fontWeight;
			font-style: normal;
		}
		a {
			color: inherit;
			text-decoration: none;
			border-bottom: 0.05em solid;
			white-space: nowrap;
		}
	}
	.contentModule--introSlider {
		top: 0; right: 0;
		height: 100vh;

		@slides__padding : 3.5rem;
		@dots__height    : 3em;
		@dot__height     : 0.65em;

		.agile {
			display: flex;
			flex-direction: column;
			height: 100%;
			will-change: background-color;

			&__list {
				//background-color: fade(green, 20);
				display: flex;
				flex-grow: 1;
			}
				&__track {
					//background-color: fade(green, 20);
					flex-grow: 1;
					display: flex;
				}
				&__slide {
					height: 100%;

					&--ratio-p {
						padding: @slides__padding;
						padding-bottom: @slides__padding*0.25;
					}
					&--ratio-s {
						padding: @slides__padding;
						padding-bottom: @slides__padding*0.25;
					}
					&--ratio-l {
						padding: @slides__padding*0.5;
						padding-bottom: @slides__padding*0.1;
					}
				}
				&__slideContent {
					height: 100%;

					background-repeat: no-repeat;
					background-position: center;
					background-size: contain;
				}

			&__dots {
				//background-color: fade(red, 20);
				display: flex;
				justify-content: center;
				align-self: flex-end;
				width: 100%;
				height: @dots__height;
			}
				&__dot {
					margin: 0 0.35em;
					width: @dot__height; height: @dot__height;
					border-radius: 50%;
					text-indent: -100em;
					overflow: hidden;
					background-color: white;

					transition: all 0.25s ease;
					opacity: 0.3;

					&--current {
						opacity: 1;
					}

					button {
						display: block;
						opacity: 0;
					}
				}

			&__arrow {
				position: absolute;
				top: 0;

				&--next {
					right: 0;
				}
			}
		}
	}
	.contentModule--footerText {
		bottom: 0; left: 0;
		padding-top: 0.5em;
		background-color: white;
	}

	// linearisiere inhalt
	// setze maximale zeilen länge
	// padding vergrößern
	// slider dots verkleinern
	@media @mediaQuery__md {
		.contentModule--introText,
		.contentModule--introSlider,
		.contentModule--footerText {
			position: relative;
			width: 100vw;
			padding: 4vw;
		}
		.contentModule--introSlider {
			height: 100vw;

			.agile__dots {
				transform: scale(0.65);
				height: 2em;
			}
			.agile__slide--ratio-p,
			.agile__slide--ratio-l,
			.agile__slide--ratio-s {
				padding: 7vw;
				padding-bottom: 0em;
			}
			.agile__slide--ratio-p {
				padding-bottom: 1em;
			}
		}
		.contentModule--introText {
			padding-bottom: 1rem;

			p {
				max-width: 29.2em;
				width: 100%;
				display: block;
			}

			p.spacerLine {
				height: 0.75em;
			}
		}
		.contentModule--footerText {
			padding-top: 1rem;
			padding-bottom: 2rem;

			p.spacerLine {
				height: 0.7em;
			}
		}
	}

	// debug outlining
	[showborders1] {
		.contentModule--introText {
			background-color: fade(yellow, 50);
			& > * { outline: 1px solid darken(yellow, 8); }
		}
		.contentModule--introSlider {
			background-color: fade(orange, 60);
			& > * { outline: 1px solid darken(orange, 8); }
		}
		.contentModule--footerText {
			background-color: fade(pink, 50);
			& > * { outline: 1px solid darken(pink, 8); }
		}
	}
</style>
